import styled from '@emotion/styled';

import {CloseButton} from '@/components/CloseButton';

export const DialogContent = styled.div`
  ${CloseButton} {
    float: right;
    margin: -8px -8px 16px 16px;
  }
`;
